import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";
import { useModal } from "./Forms";

export function FloatingCTAs() {
  return (
    <a
      href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20A3%20Global%2C%20I%27d%20like%20to%20know%20more.`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-44 right-5 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_0_25px_rgba(37,211,102,0.5)] transition-transform hover:scale-110 md:bottom-24 md:flex"
      data-testid="whatsapp-cta"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}

export function MobileBottomCTA() {
  const { openInstitution, openStudent } = useModal();
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-2 gap-2 border-t border-white/10 bg-ink-0/90 p-3 backdrop-blur-xl md:hidden" data-testid="mobile-bottom-cta">
      <a href={`tel:${CONTACT.phone}`} className="flex items-center justify-center gap-2 rounded-full border border-white/15 py-3 text-sm font-medium text-white">
        <Phone className="h-4 w-4 text-brand-cyan" /> Call
      </a>
      <button onClick={openStudent} className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-brand-blue to-brand-cyan py-3 text-sm font-medium text-[#08120A]">
        Find College
      </button>
    </div>
  );
}
